// extracted by mini-css-extract-plugin
export var container = "_43-0";
export var error = "_43-9";
export var label = "_43-5";
export var light = "_43-6";
export var md = "_43-3";
export var sm = "_43-2";
export var thin = "_43-8";
export var thinBold = "_43-7";
export var vertical = "_43-4";
export var xs = "_43-1";